import {Link} from "@nike/eds";
import SnackbarContext from "../../providers/snackbar-context";
import InventoryServiceContext from "../../providers/inventoryService-context";
import {useContext} from "react";

function DownloadLink(props) {

    let preSignedUrl = undefined;

    const inventoryService = useContext(InventoryServiceContext);
    const snackbarCtx = useContext(SnackbarContext);

    const downloadPayload = async (e, region, bucket, path, version) => {
        if (preSignedUrl === undefined) {
            await inventoryService
                .getPayloadUrlOnly(region, bucket, path, version)
                .then((result) => {
                    preSignedUrl = result.data.getPayloadUrlOnly.preSignedUrl;
                })
                .catch((error) => {
                    snackbarCtx.displayMsg(error.message, "error");
                });
        }
    };

    const handleDownloadClicked = async (e) => {
        const bucket = e.currentTarget.dataset.bucket;
        const region = e.currentTarget.dataset.region;
        const path = e.currentTarget.dataset.path;
        const version = e.currentTarget.dataset.version;
        await downloadPayload(e, region, bucket, path, version);
        if (preSignedUrl !== undefined) {
            const sleep = ms => new Promise(r => setTimeout(r, ms));
            await sleep(5000);

            const fileName = props.type + "-" + path.substring(path.substring(path.lastIndexOf('/') + 1));
            fetch(preSignedUrl).then(function (t) {
                return t.blob().then((b) => {
                    const a = document.createElement("a");
                    a.href = URL.createObjectURL(b);
                    a.setAttribute("download", fileName);
                    a.click();
                });
            });
            snackbarCtx.displayMsg("Downloading, please wait...", "success");
        }
    };

    return (
      <Link
          data-bucket={props.payloadBucket}
          data-region={props.payloadRegion}
          data-path={props.payloadPath}
          data-version={props.payloadVersion}
          onClick={(e) => {
              handleDownloadClicked(e);
          }} className="eds-link">
          {props.payloadPath ? props.payloadPath.substring(props.payloadPath.lastIndexOf('/') + 1) : ""}
      </Link>
    );

}

export {DownloadLink};